module.exports = __webpack_public_path__ + "static/img/logo-NC-Pro.9b62bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-NC-Pro.png
// module id = Di6F
// module chunks = 62